import { message } from 'antd';
import { getDomain } from 'tldts';
import fetch from './fetch';
import logout from './logout';
import { getAddress } from './location';
import buildCsv from './build-csv';
import prefixInteger from './prefix-integer';
import sortConvTag from './sortConvTag';
import convertHtmlToText from './convert-html-to-text';
import textMsgParser from './text-msg-parser';
import getLastMsgContent from './get-last-msg-content';
import storage from './storage';
import getEmitter from './get-emitter';
import xss from './xss';
import { getConvTagChildren, createDurationTime } from './history';
import dataFactory from './history/data-factory';
import validatePassword from './validate-password';
import { parseImagePromise } from './parse-paste-image';
import mockApi from './mock-api';
import calcByteLen from './calc-byte-len';
import configFetch from './config-fetch';
import parseUrl from './parse-url';
import initVisitor from './init-visitor';
import getClue from './get-clue';
import { buildResponseDataToStore } from './build-statistic-data';
import fillCondition from './fill-condition';
import isBot from './isBot';
import { getGroupTreeList, getValueIdList } from './agent-group-tree';
import formatAttrConfig from './format-attrs';
import removeHTMLTag from './removeHTMLTag';
import filterBlackList from './filterBlackList';
// @ts-ignore
import notification from './notification';
import { pubSub } from './pub';
import { versionConfig, allVersionConfig, newVersionConfig } from './plan';

import { getMaxMinDate } from './history';
import { getWidAndHei, breakSvg } from './conv';
import { setSameSiteCookie } from './set-cookie';
import { uuid } from './uuid';
import { combineTimeData } from './report-data-util';
import customizedLogout from './customized-logout';
import { isHiddenMenu, isHiddenFunction } from './custom-setting';
import networkNotification from './network-notification';
import renderChatLinkTpl from './chat-link';

import { getRegxDataByTwoFacotor, getRegxData, regxContent, regxContentWithAttr } from './editor';

import cloneElement from './clone-element';
import noAuthMessage from '@/apps/base/components/no-auth-message';
import { NO_PROMOTION_CODE } from '@/apps/base/tour/config';
import Cookies from 'js-cookie';

const { generateClient } = dataFactory;

const { checkPermission, createNotification } = notification;

export {
  fetch,
  logout,
  getAddress,
  buildCsv,
  prefixInteger,
  sortConvTag,
  convertHtmlToText,
  textMsgParser,
  getLastMsgContent,
  storage,
  getEmitter,
  xss,
  getConvTagChildren,
  validatePassword,
  parseImagePromise,
  mockApi,
  calcByteLen,
  configFetch,
  parseUrl,
  initVisitor,
  generateClient,
  createDurationTime,
  getClue,
  buildResponseDataToStore,
  fillCondition,
  isBot,
  getGroupTreeList,
  getValueIdList,
  formatAttrConfig,
  removeHTMLTag,
  filterBlackList,
  checkPermission,
  createNotification,
  pubSub,
  versionConfig,
  allVersionConfig,
  newVersionConfig,
  getMaxMinDate,
  getWidAndHei,
  breakSvg,
  setSameSiteCookie,
  uuid,
  combineTimeData,
  customizedLogout,
  isHiddenMenu,
  isHiddenFunction,
  networkNotification,
  getRegxDataByTwoFacotor,
  getRegxData,
  regxContent,
  regxContentWithAttr,
  renderChatLinkTpl,
  cloneElement
};

export function convertTagTree(categories: any[], tags: any[]): any[] {
  const map = tags.reduce<Record<number, any[]>>((res, tag) => {
    if (!res[tag.category_id]) {
      res[tag.category_id] = [];
    }
    res[tag.category_id].push(tag);
    return res;
  }, {});
  return categories.map(item => ({ ...item, id: `tag-category-${item.id}`, children: map[item.id] || [] }));
}
export function convertTagMap(data: any[]) {
  return data.reduce((res, item) => {
    res[item.id] = item;
    return res;
  }, {});
}

export function messageNoAuthAccount() {
  if (localStorage.getItem(NO_PROMOTION_CODE) === 'true') {
    noAuthMessage.show();
  } else {
    message.destroy();
    message.warning('请先完成账号授权');
  }
}

const domain = getDomain(window.location.host) as string;
export const setCookie: typeof Cookies.set = (key, value, options) => {
  return Cookies.set(key, value, options ? { ...options, domain } : { domain });
};
export const removeCookie: typeof Cookies.remove = (key, options) => {
  return Cookies.remove(key, options ? { ...options, domain } : { domain });
};

const PERSPECTIVE_MODE_KEY = '_perspective_mode';
export const openPerspectiveMode = () => {
  setCookie(PERSPECTIVE_MODE_KEY, 'true');
};
export const closePerspectiveMode = () => {
  removeCookie(PERSPECTIVE_MODE_KEY);
};
export const isPerspectiveMode = () => {
  return Cookies.get(PERSPECTIVE_MODE_KEY) === 'true';
};

export const getMarkKey = () => {
  const userId = Cookies.get('_agent_id');
  const entId = Cookies.get('_enterprise_id');
  return `user${userId}_entId${entId}`;
};
